<template>
	<div>
		<div class="mb-2 float-right">
			<button class="btn btn-primary" @click="saveTimetable">{{$t('save')}}</button>
		</div>
		<h1>{{$t('timetable')}}</h1>
		<template v-if="!loading">
			<div class="form-group">
				<label>{{$t('name')}}</label>
				<input
					type="text"
					class="form-control"
					v-model="timetable.name"
				>
			</div>
			<div class="row">
				<div class="col-md-3">
					<div class="form-group">
						<label>{{ $t('status') }}</label>
						<select
							type="date"
							v-model="timetable.status"
							class="form-control"
						>
							<option value="1">Draft</option>
							<option value="2">Published</option>
						</select>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group">
						<label>{{ $t('from') }}</label>
						<input
							type="date"
							v-model="timetable.datefrom"
							class="form-control"
						>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group">
						<label>{{ $t('to') }}</label>
						<input
							type="date"
							v-model="timetable.dateto"
							class="form-control"
						>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group">
						<label>{{ $t('start-week-number') }}</label>
						<input
							type="number"
							v-model="timetable.startweek"
							class="form-control"
						>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-4">
					<button 
						class="btn mb-2" 
						:class="`${timetable.isnextyear ? 'btn-primary' : 'btn-outline-secondary'}`"
						@click="timetable.isnextyear = !timetable.isnextyear"
					>
						<b-icon :icon="timetable.isnextyear ? 'check-circle' : 'x-circle'" scale="0.8" class="mr-2" />{{ $t("next-school-year") }}
					</button>
				</div>
			</div>
		</template>
		<template v-else>
			<div v-for="n in 2" :key="n">
				<div class="skeleton midnight h32 w200 mr-4 mb-3"></div>
				<div class="skeleton midnight h32 mr-4 mb-3"></div>
			</div>
		</template>

	</div>
</template>

<script>
export default {
	components: {
	},
	data() {
		return {
			error: null,
			loading: true,
			submitting: false,
			id: Number(this.$route.params.timetableid),
			timetable: {
				name: '',
				status: 1 ,
				datefrom: null ,
				dateto: null ,
				startweek: 1 ,
				isnextyear: false
			}
		}
	},
	mounted() {
		this.fetchTimetable().then(() => {
			this.loading = false
		})
	},
	methods: {
		fetchTimetable() {
			if (!this.id) return Promise.resolve()

			return this.$cfetch(`${this.$settings.APIBaseURL}/timetable/tttimetable/get`, {
				data: {
					tttimetable_id: Number(this.$route.params["timetableid"])
				},
			}).then((res) => {
				if (res.status !== "SUCCESS") throw new Error()

				this.timetable = res.result
			}).catch(err => {
				console.error(err)
				this.$log.error.call(this, err)
				this.$store.commit('openDialog', {
					title: this.$t('something-went-wrong'),
					content: this.$t('failed-load-timetable'),
					confirmCallBack() {
						this.$router.push('/timetables')
					}
				})
			})
		},
		saveTimetable() {
			if (this.submitting) return

			this.submitting = true
			this.$store.commit('showBlockingSpinner')

			this.$cfetch(`${this.$settings.APIBaseURL}/timetables/save`, {
				data: this.timetable,
				method: 'POST'
			}).then((res) => {
				if (res.status !== 'SUCCESS') throw new Error()

				this.$store.commit("openDialog", {
					title: this.$t("saved"),
					content: this.$t("timetable-saved"),
					confirmCallBack() {
						this.$router.push(`/timetables/edit/${res.result.id}`);
					}
				})
			}).catch(err => {
				console.error(err)
				this.$log.error.call(this, err)
				this.$store.commit('openDialog', {
					title: this.$t('something-went-wrong'),
					content: this.$t('failed-load-timetable'),
					confirmCallBack() {
						this.$router.push('/timetables')
					}
				})
			}).finally(() => {
				this.$store.commit('hideBlockingSpinner')
				this.submitting = false
			})
		}

	},
	computed: {
	}
};
</script>
